export default {
  grouping: {
    groupBy: "Grouper par",
    assetClass: "Classe d'actifs",
    currency: "Devise",
    sector: "Secteur",
    region: "Région",
    strategy: "Stratégie",
    uncategorized: "Non catégorisé",
  },
  pages: {
    avg: "Moyenne",
    max: "Max",
    min: "Min",
    footer: {
      page: "Page",
    },
    strategyReport: {
      title: "Proposition d'investissement",
      strategyName: (ctx) =>
        `Nom de la stratégie : ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
      forRecipient: (ctx) => `Pour : ${ctx.named("recipient")}`,
      preparedBy: (ctx) => `Préparé par : ${ctx.named("author")}`,
      period: (ctx) => `Période : ${ctx.named("periodStart")} - ${ctx.named("periodEnd")}`,
    },
    tableOfContents: {
      title: "Table des matières",
    },
    portfolioComposition: {
      title: "Composition du portefeuille",
      currencyAlloc: "Répartition par devise",
      assetClassAlloc: "Répartition par classe d'actifs",
      sectorAlloc: "Répartition par secteur",
      regionAlloc: "Répartition par région",
      composition: "Composition",
    },
    performanceAnalysis: {
      title: "Analyse de la performance",
      investGrowth: "Croissance de l'investissement",
      keyPerfStats: {
        title: "Statistiques clés de performance",
      },
      histYearyRets: "Rendements annuels historiques",
      histMonthRets: "Rendements mensuels historiques",
    },
    riskAnalysis: {
      title: "Analyse du risque",
      drawdownAnalysis: "Analyse des pertes",
      drawdownTable: {
        title: "Tableau des pertes",
        drawdownRank: "Rang de perte",
        startDate: "Date de début",
        troughDate: "Date de creux",
        recoveryDate: "Date de reprise",
      },
    },
    portfolioHoldings: {
      title: "Détentions du portefeuille",
      topHoldings: {
        title: "Principales positions",
        name: "Nom",
        isin: "ISIN",
        currency: "Devise",
        assetClass: "Classe d'actifs",
        sector: "Secteur",
        region: "Région",
        weight: "Poids",
      },
    },
  },
  productPicker: {
    add: "Ajouter",
    searchPlaceholder: "Rechercher un produit...",
  },
  report: {
    backToInputs: "Retour aux saisies",
    downloadReport: "Télécharger le rapport",
    taskFailed: (ctx) => `La tâche ${ctx.named("taskName")} a échoué : ${ctx.named("reason")}`,
  },
  reportInputs: {
    generateReport: "Générer le rapport",
    fields: {
      general: {
        title: "Général",
        portfolioName: "Nom du portefeuille",
        currency: "Devise",
        author: "Auteur",
        recipient: "Destinataire",
        totalCapital: (ctx) => `Capital total (${ctx.named("currency")})`,
        totalCapitalTooltip:
          "Sert à afficher le montant investi de chaque position dans le tableau des principales détentions, en supposant ce capital à la fin de la période. Laisser vide pour masquer cette colonne.",
      },
      composition: {
        title: "Composition",
        product: "Produit",
        availableFrom: "Disponible à partir du",
        availableUntil: "Disponible jusqu'au",
        period: "Période",
        fullPeriod: "Période complète",
        weight: "Poids (%)",
        addProduct: "Ajouter un produit",
        total: "Total",
        selectOneProduct:
          "Sélectionnez au moins un produit dans la composition pour pouvoir sélectionner une période.",
        noOverlappingPricePeriod:
          "Les produits sélectionnés n'ont pas d'historique de prix commun, une période de reporting ne peut donc pas être sélectionnée.",
      },
      miscellaneous: {
        title: "Divers",
        numMonthlyReturns: "Nombre d'années pour les rendements mensuels historiques",
        numTopHoldings: "Nombre de positions pour les principales détentions",
        numTopHoldingsTooltip: "Laisser vide pour obtenir toutes les positions.",
      },
    },
  },
  weightOptimization: {
    portfoliosWeightsAllocation: "Répartition des pondérations des portefeuilles",
    addProduct: "Ajouter un produit",
    addPortfolio: "Ajouter un portefeuille",
    total: "Total",
    chartsAndTables: {
      buttonText: "Générer les graphiques et tableaux",
      dataLoadError:
        "Une erreur s'est produite lors du chargement des données. Veuillez réessayer ou contacter Alquant AG si le problème persiste.",
      drawdowns: "Pertes",
      performance: "Performance",
      period: "Période",
      periodSelectionCondition:
        "Vérifiez que chaque composant avec un poids non nul dans un portefeuille a un produit sélectionné.",
      returnToRiskSpace: "Retour à l'espace risque",
      selectedPortfolios: "Portefeuilles sélectionnés",
      statistics: "Statistiques",
      year: "Année",
      yearlyReturns: "Rendements annuels",
    },
    actionTooltip: {
      restoreDefaultPortfolio: (ctx) =>
        `Revenir à l'allocation par défaut pour « ${ctx.named("portfolioName")} ».`,
      optimizeWeight: (ctx) =>
        `Optimiser les pondérations pour « ${ctx.named("portfolioName")} » selon les contraintes et objectifs.`,
      cantOptimizeWeight:
        "L'optimisation nécessite un produit sélectionné pour chaque ligne, ainsi qu'au moins une position.",
      usePortfolioToGenerateReport: (ctx) =>
        `Générer un rapport avec le portefeuille « ${ctx.named("portfolioName")} ».`,
      cantGenerateReport:
        "La génération de rapport nécessite un produit sélectionné pour chaque ligne et une allocation totale de 100 %.",
      removePortfolio: (ctx) => `Retirer « ${ctx.named("portfolioName")} » de la comparaison.`,
      cantRemovePortfolio: "Au moins un portefeuille doit rester dans la comparaison.",
    },
    optimizationDialog: {
      title: "Paramètres d'optimisation",
      objective: "Objectif",
      period: "Période d'optimisation",
      bounds: "Bornes d'allocation",
      addBound: "Ajouter une borne",
      singlePosition: "Position unique",
      type: "Type",
      target: "Cible",
      min: "Min",
      max: "Max",
      buttonText: "Lancer l'optimisation",
      optimization: {
        maxRetWithTargetMaxVol: {
          name: "Maximiser le rendement (volatilité annuelle cible)",
          targetTitle: "Volatilité annuelle maximale",
        },
        maxRetWithTargetPainIndex: {
          name: "Maximiser le rendement (pain index cible)",
          targetTitle: "Pain index maximum",
        },
        maxRetWithTargetMaxDrawdown: {
          name: "Maximiser le rendement (drawdown cible)",
          targetTitle: "Drawdown maximum",
        },
        minVolWithTargetMinRet: {
          name: "Minimiser la volatilité (rendement annuel cible)",
          targetTitle: "Rendement annuel minimum",
        },
        minDrawdownWithTargetMinRet: {
          name: "Minimiser la perte maximale (rendement annuel cible)",
          targetTitle: "Rendement annuel minimum",
        },
        maxSharpe: {
          name: "Maximiser le ratio de Sharpe",
        },
        maxSortino: {
          name: "Maximiser le ratio de Sortino",
        },
      },
    },
    failedOptimizationDialog: {
      title: "Échec de l'optimisation",
      text: "Aucune solution trouvée. Les contraintes (valeurs cibles et limites d'allocation) peuvent être trop restrictives.",
    },
  },
};
